// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import SimModal from '@/plugins/SimulatorModal'

import '@styles/general.scss'

Vue.config.productionTip = false
Vue.use(SimModal)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});

window.addEventListener("drop", function(e) {
  e = e || event;
  e.preventDefault();
}, false);
window.addEventListener("dragover",function(e){
  e = e || event;
  e.preventDefault();
}, false);


// WEBPACK FOOTER //
// ./src/main.js